import { render, staticRenderFns } from "./goTop.vue?vue&type=template&id=05d96aa2&scoped=true"
import script from "./goTop.vue?vue&type=script&lang=js"
export * from "./goTop.vue?vue&type=script&lang=js"
import style0 from "./goTop.vue?vue&type=style&index=0&id=05d96aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d96aa2",
  null
  
)

export default component.exports